import React, { useState } from "react";
import DataTable from "../UI/table/DataTable";
import { useQuery } from "react-query";
import { deleteCities, getCities, updateCities } from "../../MyApi/admin/cities";
import StatusBadge from "../UI/statusBadge";
import TableActions from "../UI/table/TableActions";
import AddCitiesModal from "./storemodals/citiesmodal";
import i18next from "i18next";

const CitiesComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState("");

  const lang = i18next.language;

  const { data, isLoading, refetch } = useQuery(
    ["cities-data", lang],
    () => getCities(lang)
  );

  const citiesColumns = [
    { label: "اسم المدينة", accessor: "name" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => openModal("edit", row.id)}
          deleteFn={deleteCities}
          refetch={refetch}
          mutationKey={"deleteCities"}
          id={row.id}
          editPermission="update_city"
          deletePermission="delete_city"
          togglePermission="update_city"
          toggleMutationKey={"toggle-update-city"}
          toggleFn={(id, status) => updateCities({is_active: status, "_method": "PUT", lang: i18next.language}, i18next.language, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

  const systemData = data?.data?.cities || [];

  const openModal = (mode, id) => {
    setShowModal(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMode("add");
    setModalId("");
  };

  return (
    <>
      <DataTable
        actionLabel="إضافة المدن"
        createPermission="create_city"
        onAddClick={() => openModal("add")}
        title="المدن"
        columns={citiesColumns}
        data={systemData}
        isLoading={isLoading}
      />
  {showModal &&    <AddCitiesModal
        show={showModal}
        onClose={closeModal}
        refetch={refetch}
        modalMode={modalMode}
        modalId={modalId}
      />}
    </>
  );
};

export default CitiesComponent;
